module.exports = __webpack_public_path__ + "img/building2.87242e71.png";